/* Imports */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
import LoginNovo from "@/components/auth/LoginNovo";
import SolicitarRecuperacaoSenha from '@/components/auth/SolicitarRecuperacaoSenha'
import RecuperarSenha from '@/components/auth/RecuperarSenha'
import Dashboard from '@/components/dashboard/Dashboard'
import ClienteCadastro from '@/components/clientes/Cadastro'
import ClienteEditar from '@/components/clientes/Editar'
import ClienteIndicacao from '@/components/clientes/Indicacao'
import ClienteImportacao from '@/components/clientes/Importacao'
import ClienteObrigacoesFinanceiras from '@/components/clientes/ObrigacoesFinanceiras'
import ClientePadraoDeVida from '@/components/clientes/PadraoDeVida'
import ClientePatrimonio from "@/components/clientes/Patrimonio.vue"
import ClienteSegurosFonteDeRenda from "@/components/clientes/SegurosFonteDeRenda"
import Perfil from '@/components/perfil/Perfil'
import EmpresaListagem from '@/components/empresas/Listagem'
import EmpresaRelatorio from '@/components/empresas/Relatorio'
import EmpresaRelatorioProducao from '@/components/empresas/RelatorioProducao'

import EmpresaCadastro from '@/components/empresas/Cadastro'
import EmpresaEditar from '@/components/empresas/Editar'

import EmpresaProducao from '@/components/empresas/Producao'
import UsuarioListagem from '@/components/usuarios/Listagem'
import UsuarioCadastro from '@/components/usuarios/Cadastro'
import UsuarioEditar from '@/components/usuarios/Editar'
import UsuarioDesempenho from '@/components/usuarios/Desempenho'

import usuarioListagem from '@/components/usuarios/Listagem'
import usuarioCadastro from '@/components/usuarios/Cadastro'
import usuarioEditar from '@/components/usuarios/Editar'
import usuarioDesempenho from '@/components/usuarios/Desempenho'

import ProdutoListagem from '@/components/produtos/Listagem'
import ProdutoCadastro from '@/components/produtos/Cadastro'
import ProdutoEditar from '@/components/produtos/Editar'
import CategoriaListagem from '@/components/categorias/Listagem'
import CategoriaCadastro from '@/components/categorias/Cadastro'
import CategoriaEditar from '@/components/categorias/Editar'
import PedidoResumo from '@/components/pedidos/Resumo'
import GerenciamentoLead from '@/components/lead/GerenciamentoLead'
import LeadListagem from '@/components/lead/Listagem'
import LeadListagemRemovidos from '@/components/lead/ListagemRemovidos'
import AgendaCadastro from '@/components/agenda/Cadastro'
import AgendaEditar from '@/components/agenda/Editar'
import AgendaSistemaEditar from '@/components/agenda-sistema/Editar'
import CampanhaListagem from '@/components/campanha/Listagem'
import CampanhaCadastro from '@/components/campanha/Cadastro'
import CampanhaEditar from '@/components/campanha/Editar'
import CampanhaClientes from '@/components/campanha/Clientes'
import ResultadoBusca from '@/components/busca/Resultado'
import Ajuda from '@/components/ajuda/Tutorial'
import Page403 from '@/components/auth/Page403'
import RelatorioDesempenho from '@/components/relatorios/Desempenho'
import Relatoriousuario from '@/components/relatorios/Funcionario';
import RelatorioParceiro from '@/components/relatorios/Parceiro';
import RelatorioSimulador from '@/components/relatorios/Simulador';

import Simulador from "@/components/simulador/Simulador.vue";
import Patrimonio from "@/components/clientes/Patrimonio.vue";
import Projeto from "@/components/clientes/Projeto.vue";
import Projetos from "@/components/clientes/Projetos.vue";

import IndependenciaFinanceira from "@/components/clientes/IndependenciaFinanceira.vue";
import EducacaoFilhos from "@/components/clientes/EducacaoFilhos.vue";
import ContribuicaoParaPrevidenciaPGBL from "@/components/clientes/ContribuicaoParaPrevidenciaPGBL.vue";
import DespesaFilho   from "@/components/clientes/DespesaFilho.vue";
import InformacaoAdicional from "@/components/clientes/InformacaoAdicional.vue";

import GerenciamentoLeadSimulador from '@/components/lead/GerenciamentoLeadSimulador'

import ClientesSimulador from "@/components/lead/ClientesSimulador";

import IrpfAnualForm from "@/components/irpf-anual/Form.vue";
import PrevidenciaOficialForm from "@/components/previdencia-oficial/Form.vue";

import DescontoSimplificadoForm from "@/components/desconto-simplificado/Form.vue";

import EmpresaUploadLogos from "@/components/empresas/UploadLogos.vue";

import Auth from "@/store/auth.js";
import { api } from "../helpers/api"

Vue.use(Router);

const mudarLayoutSimulador = async (to, from, next) => {

    const status = await Auth.statusSimulador();

    to.meta.layout = 'default';

    if (status == 2) {
        to.meta.layout = 'simulador';
    }

    return next();
};

const redirecionarSimulador = async (to, from, next) => {

    const status = await Auth.statusSimulador();

    if (status == 2) {
        return next({name: 'clientesSimulador'});
    }

    return next();
};

const routes = new Router({

    scrollBehavior() {
		return {
			x: 0,
			y: 0
		};
	},
    mode: 'hash',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: LoginNovo,
            meta: {
                layout: 'Guest',
                guest: true
            }
        },
        {
            path: '/login-antigo',
            name: 'LoginAntigo',
            component: Login,
            meta: {
                layout: 'Guest',
                guest: true
            }
        },
        {
            path: '/solicitar-recuperar-senha',
            name: 'solicitar_recuperar_senha',
            component: SolicitarRecuperacaoSenha,
            meta: {
                layout: 'Guest',
                guest: true,
            }
        },

        {
            path: '/recuperar-senha/:token',
            name: 'recuperar_senha',
            component: RecuperarSenha,
            meta: {
                layout: 'Guest',
                guest: true,
            }
        },
        {
            path: '/',
            name: 'Dashboard',
            component: async () => {

                const status = await Auth.statusSimulador();

                if (status == 2) {
                    return ClientesSimulador;
                }

                return Dashboard
            },
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/cliente/cadastro',
            name: 'cliente-cadastro',
            component: ClienteCadastro,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/clientes',
            name: 'clientes',
            component: ClienteIndicacao
        },
        {
            path: '/cliente/:id',
            name: 'cliente-editar',
            component: ClienteEditar
        },
        {
            path: '/clientes/importacao/',
            name: 'cliente-importacao',
            component: ClienteImportacao
        },
        {
            path: '/cliente/:id/padrao-de-vida',
            name: 'cliente_padrao_vida',
            component: ClientePadraoDeVida,
            meta: {
                layout: 'simulador'
            }
        },
        {
            path: "/cliente/:id/patrimonio",
            name: 'patrimonio',
            component: Patrimonio,
            meta: {
                layout: 'simulador'
            }
        },
        {
            path: "/cliente/:id/obrigacoes-financeiras",
            name: 'cliente_obrigacoes_financeiras',
            component: ClienteObrigacoesFinanceiras,
            meta: {
                layout: 'simulador'
            }
        },
        {
            path: '/perfil',
            name: 'Perfil',
            component: Perfil,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/empresas',
            name: 'empresas',
            component: EmpresaListagem,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/empresas/relatorio',
            name: 'empresas',
            component: EmpresaRelatorio,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/empresas/relatorio-producao',
            name: 'empresas',
            component: EmpresaRelatorioProducao,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/empresa/cadastro',
            name: 'empresaCadastro',
            component: EmpresaCadastro,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/empresa/editar/:id',
            name: 'empresaEditar',
            component: EmpresaEditar,
            beforeEnter: mudarLayoutSimulador,
        },
        {

            path: '/empresa/producao/:id',
            name: 'empresaProducao',
            component: EmpresaProducao,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/usuarios',
            name: 'usuarioListagem',
            component: usuarioListagem,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/usuario/cadastro',
            name: 'usuarioCadastro',
            component: usuarioCadastro,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/usuario/editar/:id',
            name: 'usuarioEditar',
            component: usuarioEditar,
            beforeEnter: mudarLayoutSimulador,
        },
        {
            path: '/usuarios/desempenho',
            name: 'usuarioDesempenho',
            component: usuarioDesempenho
        },
        {
            path: '/relatorios/desempenho',
            name: 'relatorioDesempenho',
            component: RelatorioDesempenho
        },
        {
            path: '/relatorios/usuario',
            name: 'relatoriousuario',
            component: Relatoriousuario
        },
        {
            path: '/relatorios/parceiro',
            name: 'relatorioParceiro',
            component: RelatorioParceiro
        },
        {
            path: '/relatorios/simulador/:id',
            name: 'relatoriosimulador',
            component: RelatorioSimulador,
            meta: {
                layout: 'simulador'
            }
        },
        {
            path: '/produtos',
            name: 'produtoListagem',
            component: ProdutoListagem
        },
        {
            path: '/produto/cadastro',
            name: 'produtoCadastro',
            component: ProdutoCadastro,
        },
        {
            path: '/produto/editar/:id',
            name: 'produtoEditar',
            component: ProdutoEditar,
        },
        {
            path: '/categorias',
            name: 'categoriaListagem',
            component: CategoriaListagem
        },
        {
            path: '/categoria/cadastro',
            name: 'categoriaCadastro',
            component: CategoriaCadastro,
        },
        {
            path: '/categoria/editar/:id',
            name: 'categoriaEditar',
            component: CategoriaEditar,
        },
        {
            path: '/pedido/resumo/:id',
            name: 'pedidoResumo',
            component: PedidoResumo
        },
        {
            path: '/lead-gerenciamento/:pedidoId',
            name: 'gerenciamentoLead',
            component: GerenciamentoLead
        },
        {
            path: '/gerenciamento-leads',
            name: 'gerenciamentoLeads',
            component: LeadListagem,
            beforeEnter: redirecionarSimulador
        },
        {
            path: '/gerenciamento-leads-removidos',
            name: 'gerenciamentoLeadsRemovidos',
            component: LeadListagemRemovidos
        },
        {
            path: '/agenda/cadastro',
            name: 'agendaCadastro',
            component: AgendaCadastro
        },
        {
            path: '/agenda/:id',
            name: 'agendaEditar',
            component: AgendaEditar
        },
        {
            path: '/agenda-sistema/:id',
            name: 'agendaSistemaEditar',
            component: AgendaSistemaEditar
        },
        {
            path: '/campanhas',
            name: 'campanhaListagem',
            component: CampanhaListagem
        },
        {
            path: '/campanha/cadastro',
            name: 'campanhaCadastro',
            component: CampanhaCadastro
        },
        {
            path: '/campanha/:id',
            name: 'campanhaEditar',
            component: CampanhaEditar
        },
        {
            path: '/campanha/clientes/:id',
            name: 'campanhaClientes',
            component: CampanhaClientes
        },
        {
            path: '/usuarios/desempenho',
            name: 'desempenho',
            component: usuarioDesempenho
        },
        {
            path: '/busca',
            name: 'resultadoBusca',
            component: ResultadoBusca
        },
        {
            path: '/ajuda',
            name: 'Ajuda',
            component: Ajuda
        },
        {
            path: '/sempermissao',
            name: 'sempermissao',
            component: Page403
        },

        {
            path: '/cliente/:id/simulador',
            name: 'cliente_simulador',
            component: Simulador,
            meta: {
                layout: 'simulador'
            }
        },

        //
        {
            path: "/cliente/:id/patrimonio",
            name: 'cliente_patrimonio',
            component: Patrimonio,
            meta: {
                layout: 'simulador'
            }
        },

        //
        {
            path: "/cliente/:cliente_id/projeto/:projeto_id",
            name: 'projeto',
            component: Projeto,
            meta: {
                layout: 'simulador'
            }
        },


        //
        {
            path: "/cliente/:id/projetos",
            name: 'cliente_projetos',
            component: Projetos,
            meta: {
                layout: 'simulador'
            }
        },

        //

        {
            path: "/cliente/:id/seguros-fonte-renda",
            name: 'cliente_seguros_fonte_renda',
            component: ClienteSegurosFonteDeRenda,
            meta: {
                layout: 'simulador'
            },


        },
        //

        {
            path: "/cliente/:id/independencia-financeira",
            name: 'cliente_independencia_financeira',
            component: IndependenciaFinanceira,
            meta: {
                layout: 'simulador'
            }
        },

        //

        {
            path: "/cliente/:id/educacao-filhos",
            name: 'cliente_educacao_filhos',
            component: EducacaoFilhos,
            meta: {
                layout: 'simulador'
            }
        },

        //

        {
            path: "/educacao-filho/:id",
            component: DespesaFilho,
            name: 'cliente_despesa_filho',
            meta: {
                layout: 'simulador'
            }
        },

        //

        {
            path: "/cliente/:id/informacao-adicional",
            component: InformacaoAdicional,
            name: 'cliente_informacoes_adicionais',
            meta:  {
                layout: 'simulador'
            }
        },

        {
            path: "/cliente/:id/perfil-investidor",
            component: () => import('../components/clientes/PerfilInvestidor.vue'),
            name: 'perfil_investidor',
            meta:  {
                layout: 'simulador'
            }
        },

        //

        {
            path: '/lead-gerenciamento-simulador/:pedidoId',
            name: 'gerenciamentoLeadSimulador',
            component: GerenciamentoLeadSimulador,
            meta: {
                layout: 'simulador'
            }
        },

        //

        {

            path: '/clientes-simulador',
            name: 'clientesSimulador',
            component: ClientesSimulador,
            meta: {
                layout: 'simulador'
            }
        },

         {
            path: "/cliente/:id/contribuicao-para-previdencia-pgbl",
            name: 'cliente_contribuicao_previdencia_pgbl',
            component: ContribuicaoParaPrevidenciaPGBL,
            meta: {
                layout: 'simulador'
            }
        },


        {
            path: "/cliente/:id/contribuicao-para-previdencia-vgbl",
            name: 'cliente_contribuicao_previdencia_vgbl',
            component: () => import('@/components/clientes/ContribuicaoParaPrevidenciaVGBL.vue'),
            meta: {
                layout: 'simulador'
            }
        },

        //

        {
            path: '/irpf-anual/:ano',
            name: 'irpf_anual',
            component: IrpfAnualForm,
            meta: {
                layout: 'simulador'
            }
        },

        //

        {
            path: '/previdencia-oficial/:ano',
            name: 'previdencia_oficial',
            component: PrevidenciaOficialForm,
            meta: {
                layout: 'simulador'
            }
        },

        //


        {
            path: '/desconto-simplificado/:ano',
            name: 'desconto_simplificado',
            component: DescontoSimplificadoForm,
            meta: {
                layout: 'simulador'
            }
        },



        {
            path: '/aliquotas-patrimoniais-grupo/:id/ano/:ano',
            name: 'aliquota_patrimonial_grupo',
            meta: {
                layout: 'simulador'
            },

            component: () => import('@/components/aliquota-patrimonial-grupo/Form.vue')
        },

        //


        {
            path: '/empresa/:id/upload-logos',
            component: EmpresaUploadLogos,
            name: 'empresa_upload_logo',
            beforeEnter: mudarLayoutSimulador,
        },

        {
            path: '/empresa/:id/tema',
            component: () => import('@/components/empresas/Tema.vue'),
            name: 'empresa_tema',
            beforeEnter: mudarLayoutSimulador,
        },


        {
            path: '/configuracoes',
            name: 'configuracoes',
            meta: {
                layout: 'simulador'
            },
            component: () => import('@/components/Configuracoes.vue')
        },


        {
            path: '/versao',

            name: 'versao',

            meta: {
                layout: 'simulador'
            },

            component: () => import('@/components/Versao.vue')

        }
    ]
});


routes.beforeEach(async (to, from, next) => {


	if (to.meta && to.meta.guest && !localStorage.getItem('api_token')) {
		return next();
	}

	try{

        // await store.dispatch('carregarDadosAutenticacao');

        await Auth.loadInfo();
        Auth.changeStyle();

		next();

	} catch(e) {

        localStorage.removeItem('token');

        let query;

        if (e.response.status == 401
            && e.response.data.result
            && e.response.data.result.data
            && e.response.data.result.data.token_invalidado
        ) {
            query = {error: 'revoked_token'}
        }

        else if (e.response.status == 404) {
            throw e;
        }

		next({name: 'Login', query})
	}
})


export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js